(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["EsuitePlatformClient"] = factory();
	else
		root["EsuitePlatformClient"] = factory();
})(this, function() {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 462:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ApiVersion": () => /* reexport */ ApiVersion,
  "AuthLinkFromJSON": () => /* reexport */ AuthLinkFromJSON,
  "AuthLinkFromJSONTyped": () => /* reexport */ AuthLinkFromJSONTyped,
  "AuthLinkToJSON": () => /* reexport */ AuthLinkToJSON,
  "BASE_PATH": () => /* reexport */ BASE_PATH,
  "BaseAPI": () => /* reexport */ BaseAPI,
  "BlobApiResponse": () => /* reexport */ BlobApiResponse,
  "COLLECTION_FORMATS": () => /* reexport */ COLLECTION_FORMATS,
  "CacheCompression": () => /* reexport */ CacheCompression,
  "CacheCompressionFromJSON": () => /* reexport */ CacheCompressionFromJSON,
  "CacheCompressionFromJSONTyped": () => /* reexport */ CacheCompressionFromJSONTyped,
  "CacheCompressionToJSON": () => /* reexport */ CacheCompressionToJSON,
  "CacheIsLiveResponseDtoFromJSON": () => /* reexport */ CacheIsLiveResponseDtoFromJSON,
  "CacheIsLiveResponseDtoFromJSONTyped": () => /* reexport */ CacheIsLiveResponseDtoFromJSONTyped,
  "CacheIsLiveResponseDtoToJSON": () => /* reexport */ CacheIsLiveResponseDtoToJSON,
  "CacheUrlRequestDtoFromJSON": () => /* reexport */ CacheUrlRequestDtoFromJSON,
  "CacheUrlRequestDtoFromJSONTyped": () => /* reexport */ CacheUrlRequestDtoFromJSONTyped,
  "CacheUrlRequestDtoToJSON": () => /* reexport */ CacheUrlRequestDtoToJSON,
  "Configuration": () => /* reexport */ Configuration,
  "DefaultApi": () => /* reexport */ DefaultApi,
  "EsuitePlatformClient": () => /* reexport */ EsuitePlatformClient,
  "FetchJsonOptionsFromJSON": () => /* reexport */ FetchJsonOptionsFromJSON,
  "FetchJsonOptionsFromJSONTyped": () => /* reexport */ FetchJsonOptionsFromJSONTyped,
  "FetchJsonOptionsToJSON": () => /* reexport */ FetchJsonOptionsToJSON,
  "JSONApiResponse": () => /* reexport */ JSONApiResponse,
  "KeyboardOpenDtoFromJSON": () => /* reexport */ KeyboardOpenDtoFromJSON,
  "KeyboardOpenDtoFromJSONTyped": () => /* reexport */ KeyboardOpenDtoFromJSONTyped,
  "KeyboardOpenDtoToJSON": () => /* reexport */ KeyboardOpenDtoToJSON,
  "LocalbaseFindOneOptionsFromJSON": () => /* reexport */ LocalbaseFindOneOptionsFromJSON,
  "LocalbaseFindOneOptionsFromJSONTyped": () => /* reexport */ LocalbaseFindOneOptionsFromJSONTyped,
  "LocalbaseFindOneOptionsToJSON": () => /* reexport */ LocalbaseFindOneOptionsToJSON,
  "LocalbaseFindOptionsFromJSON": () => /* reexport */ LocalbaseFindOptionsFromJSON,
  "LocalbaseFindOptionsFromJSONTyped": () => /* reexport */ LocalbaseFindOptionsFromJSONTyped,
  "LocalbaseFindOptionsToJSON": () => /* reexport */ LocalbaseFindOptionsToJSON,
  "LocalbaseUpdateOptionsFromJSON": () => /* reexport */ LocalbaseUpdateOptionsFromJSON,
  "LocalbaseUpdateOptionsFromJSONTyped": () => /* reexport */ LocalbaseUpdateOptionsFromJSONTyped,
  "LocalbaseUpdateOptionsToJSON": () => /* reexport */ LocalbaseUpdateOptionsToJSON,
  "PaymentTerminalCommandDtoFromJSON": () => /* reexport */ PaymentTerminalCommandDtoFromJSON,
  "PaymentTerminalCommandDtoFromJSONTyped": () => /* reexport */ PaymentTerminalCommandDtoFromJSONTyped,
  "PaymentTerminalCommandDtoToJSON": () => /* reexport */ PaymentTerminalCommandDtoToJSON,
  "PaymentTerminalCorrectionDtoFromJSON": () => /* reexport */ PaymentTerminalCorrectionDtoFromJSON,
  "PaymentTerminalCorrectionDtoFromJSONTyped": () => /* reexport */ PaymentTerminalCorrectionDtoFromJSONTyped,
  "PaymentTerminalCorrectionDtoToJSON": () => /* reexport */ PaymentTerminalCorrectionDtoToJSON,
  "PaymentTerminalDtoFromJSON": () => /* reexport */ PaymentTerminalDtoFromJSON,
  "PaymentTerminalDtoFromJSONTyped": () => /* reexport */ PaymentTerminalDtoFromJSONTyped,
  "PaymentTerminalDtoToJSON": () => /* reexport */ PaymentTerminalDtoToJSON,
  "PaymentTerminalPurchaseDtoFromJSON": () => /* reexport */ PaymentTerminalPurchaseDtoFromJSON,
  "PaymentTerminalPurchaseDtoFromJSONTyped": () => /* reexport */ PaymentTerminalPurchaseDtoFromJSONTyped,
  "PaymentTerminalPurchaseDtoToJSON": () => /* reexport */ PaymentTerminalPurchaseDtoToJSON,
  "PaymentTerminalRefundDtoFromJSON": () => /* reexport */ PaymentTerminalRefundDtoFromJSON,
  "PaymentTerminalRefundDtoFromJSONTyped": () => /* reexport */ PaymentTerminalRefundDtoFromJSONTyped,
  "PaymentTerminalRefundDtoToJSON": () => /* reexport */ PaymentTerminalRefundDtoToJSON,
  "PaymentTerminalStatus": () => /* reexport */ PaymentTerminalStatus,
  "PaymentTerminalStatusFromJSON": () => /* reexport */ PaymentTerminalStatusFromJSON,
  "PaymentTerminalStatusFromJSONTyped": () => /* reexport */ PaymentTerminalStatusFromJSONTyped,
  "PaymentTerminalStatusToJSON": () => /* reexport */ PaymentTerminalStatusToJSON,
  "PaymentTerminalTransactionResponseFromJSON": () => /* reexport */ PaymentTerminalTransactionResponseFromJSON,
  "PaymentTerminalTransactionResponseFromJSONTyped": () => /* reexport */ PaymentTerminalTransactionResponseFromJSONTyped,
  "PaymentTerminalTransactionResponseToJSON": () => /* reexport */ PaymentTerminalTransactionResponseToJSON,
  "PaymentTerminalTransactionType": () => /* reexport */ PaymentTerminalTransactionType,
  "PaymentTerminalTransactionTypeFromJSON": () => /* reexport */ PaymentTerminalTransactionTypeFromJSON,
  "PaymentTerminalTransactionTypeFromJSONTyped": () => /* reexport */ PaymentTerminalTransactionTypeFromJSONTyped,
  "PaymentTerminalTransactionTypeToJSON": () => /* reexport */ PaymentTerminalTransactionTypeToJSON,
  "PlatformDisplayFromJSON": () => /* reexport */ PlatformDisplayFromJSON,
  "PlatformDisplayFromJSONTyped": () => /* reexport */ PlatformDisplayFromJSONTyped,
  "PlatformDisplayToJSON": () => /* reexport */ PlatformDisplayToJSON,
  "PlatformNetworkInterfaceFromJSON": () => /* reexport */ PlatformNetworkInterfaceFromJSON,
  "PlatformNetworkInterfaceFromJSONTyped": () => /* reexport */ PlatformNetworkInterfaceFromJSONTyped,
  "PlatformNetworkInterfaceToJSON": () => /* reexport */ PlatformNetworkInterfaceToJSON,
  "PlatformOSInfoFromJSON": () => /* reexport */ PlatformOSInfoFromJSON,
  "PlatformOSInfoFromJSONTyped": () => /* reexport */ PlatformOSInfoFromJSONTyped,
  "PlatformOSInfoToJSON": () => /* reexport */ PlatformOSInfoToJSON,
  "PlatformPrinterFromJSON": () => /* reexport */ PlatformPrinterFromJSON,
  "PlatformPrinterFromJSONTyped": () => /* reexport */ PlatformPrinterFromJSONTyped,
  "PlatformPrinterToJSON": () => /* reexport */ PlatformPrinterToJSON,
  "PlatformStateFromJSON": () => /* reexport */ PlatformStateFromJSON,
  "PlatformStateFromJSONTyped": () => /* reexport */ PlatformStateFromJSONTyped,
  "PlatformStateToJSON": () => /* reexport */ PlatformStateToJSON,
  "PlayerProfileSetDtoFromJSON": () => /* reexport */ PlayerProfileSetDtoFromJSON,
  "PlayerProfileSetDtoFromJSONTyped": () => /* reexport */ PlayerProfileSetDtoFromJSONTyped,
  "PlayerProfileSetDtoToJSON": () => /* reexport */ PlayerProfileSetDtoToJSON,
  "PreviewConfigDtoFromJSON": () => /* reexport */ PreviewConfigDtoFromJSON,
  "PreviewConfigDtoFromJSONTyped": () => /* reexport */ PreviewConfigDtoFromJSONTyped,
  "PreviewConfigDtoToJSON": () => /* reexport */ PreviewConfigDtoToJSON,
  "PrintHtmlDtoFromJSON": () => /* reexport */ PrintHtmlDtoFromJSON,
  "PrintHtmlDtoFromJSONTyped": () => /* reexport */ PrintHtmlDtoFromJSONTyped,
  "PrintHtmlDtoToJSON": () => /* reexport */ PrintHtmlDtoToJSON,
  "PrintOptionsFromJSON": () => /* reexport */ PrintOptionsFromJSON,
  "PrintOptionsFromJSONTyped": () => /* reexport */ PrintOptionsFromJSONTyped,
  "PrintOptionsToJSON": () => /* reexport */ PrintOptionsToJSON,
  "PrinterResponseFromJSON": () => /* reexport */ PrinterResponseFromJSON,
  "PrinterResponseFromJSONTyped": () => /* reexport */ PrinterResponseFromJSONTyped,
  "PrinterResponseToJSON": () => /* reexport */ PrinterResponseToJSON,
  "PrinterStatus": () => /* reexport */ PrinterStatus,
  "PrinterStatusFromJSON": () => /* reexport */ PrinterStatusFromJSON,
  "PrinterStatusFromJSONTyped": () => /* reexport */ PrinterStatusFromJSONTyped,
  "PrinterStatusToJSON": () => /* reexport */ PrinterStatusToJSON,
  "RectangleFromJSON": () => /* reexport */ RectangleFromJSON,
  "RectangleFromJSONTyped": () => /* reexport */ RectangleFromJSONTyped,
  "RectangleToJSON": () => /* reexport */ RectangleToJSON,
  "RequiredError": () => /* reexport */ RequiredError,
  "ShopifyApiRequestFromJSON": () => /* reexport */ ShopifyApiRequestFromJSON,
  "ShopifyApiRequestFromJSONTyped": () => /* reexport */ ShopifyApiRequestFromJSONTyped,
  "ShopifyApiRequestToJSON": () => /* reexport */ ShopifyApiRequestToJSON,
  "SizeFromJSON": () => /* reexport */ SizeFromJSON,
  "SizeFromJSONTyped": () => /* reexport */ SizeFromJSONTyped,
  "SizeToJSON": () => /* reexport */ SizeToJSON,
  "TextApiResponse": () => /* reexport */ TextApiResponse,
  "ValidateEmailOptionsFromJSON": () => /* reexport */ ValidateEmailOptionsFromJSON,
  "ValidateEmailOptionsFromJSONTyped": () => /* reexport */ ValidateEmailOptionsFromJSONTyped,
  "ValidateEmailOptionsToJSON": () => /* reexport */ ValidateEmailOptionsToJSON,
  "VoidApiResponse": () => /* reexport */ VoidApiResponse,
  "canConsumeForm": () => /* reexport */ runtime_canConsumeForm,
  "createEsuitePlatformClient": () => /* reexport */ createEsuitePlatformClient,
  "exists": () => /* reexport */ exists,
  "mapValues": () => /* reexport */ mapValues,
  "querystring": () => /* reexport */ querystring
});

// NAMESPACE OBJECT: ./client/lib/extras/index.ts
var extras_namespaceObject = {};
__webpack_require__.r(extras_namespaceObject);
__webpack_require__.d(extras_namespaceObject, {
  "testExtra": () => testExtra
});

;// CONCATENATED MODULE: ./node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/runtime.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

const BASE_PATH = "http://localhost:3100".replace(/\/+$/, "");
const isBlob = (value) => typeof Blob !== 'undefined' && value instanceof Blob;
/**
 * This is the base class for all generated API classes.
 */
class BaseAPI {
    constructor(configuration = new Configuration()) {
        this.configuration = configuration;
        this.fetchApi = (url, init) => __awaiter(this, void 0, void 0, function* () {
            let fetchParams = { url, init };
            for (const middleware of this.middleware) {
                if (middleware.pre) {
                    fetchParams = (yield middleware.pre(Object.assign({ fetch: this.fetchApi }, fetchParams))) || fetchParams;
                }
            }
            let response = yield (this.configuration.fetchApi || fetch)(fetchParams.url, fetchParams.init);
            for (const middleware of this.middleware) {
                if (middleware.post) {
                    response = (yield middleware.post({
                        fetch: this.fetchApi,
                        url: fetchParams.url,
                        init: fetchParams.init,
                        response: response.clone(),
                    })) || response;
                }
            }
            return response;
        });
        this.middleware = configuration.middleware;
    }
    withMiddleware(...middlewares) {
        const next = this.clone();
        next.middleware = next.middleware.concat(...middlewares);
        return next;
    }
    withPreMiddleware(...preMiddlewares) {
        const middlewares = preMiddlewares.map((pre) => ({ pre }));
        return this.withMiddleware(...middlewares);
    }
    withPostMiddleware(...postMiddlewares) {
        const middlewares = postMiddlewares.map((post) => ({ post }));
        return this.withMiddleware(...middlewares);
    }
    request(context, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const { url, init } = this.createFetchParams(context, initOverrides);
            const response = yield this.fetchApi(url, init);
            if (response.status >= 200 && response.status < 300) {
                return response;
            }
            throw response;
        });
    }
    createFetchParams(context, initOverrides) {
        let url = this.configuration.basePath + context.path;
        if (context.query !== undefined && Object.keys(context.query).length !== 0) {
            // only add the querystring to the URL if there are query parameters.
            // this is done to avoid urls ending with a "?" character which buggy webservers
            // do not handle correctly sometimes.
            url += '?' + this.configuration.queryParamsStringify(context.query);
        }
        const body = ((typeof FormData !== "undefined" && context.body instanceof FormData) || context.body instanceof URLSearchParams || isBlob(context.body))
            ? context.body
            : JSON.stringify(context.body);
        const headers = Object.assign({}, this.configuration.headers, context.headers);
        const init = Object.assign({ method: context.method, headers: headers, body, credentials: this.configuration.credentials }, initOverrides);
        return { url, init };
    }
    /**
     * Create a shallow clone of `this` by constructing a new instance
     * and then shallow cloning data members.
     */
    clone() {
        const constructor = this.constructor;
        const next = new constructor(this.configuration);
        next.middleware = this.middleware.slice();
        return next;
    }
}
;
class RequiredError extends Error {
    constructor(field, msg) {
        super(msg);
        this.field = field;
        this.name = "RequiredError";
    }
}
const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};
class Configuration {
    constructor(configuration = {}) {
        this.configuration = configuration;
    }
    get basePath() {
        return this.configuration.basePath != null ? this.configuration.basePath : BASE_PATH;
    }
    get fetchApi() {
        return this.configuration.fetchApi;
    }
    get middleware() {
        return this.configuration.middleware || [];
    }
    get queryParamsStringify() {
        return this.configuration.queryParamsStringify || querystring;
    }
    get username() {
        return this.configuration.username;
    }
    get password() {
        return this.configuration.password;
    }
    get apiKey() {
        const apiKey = this.configuration.apiKey;
        if (apiKey) {
            return typeof apiKey === 'function' ? apiKey : () => apiKey;
        }
        return undefined;
    }
    get accessToken() {
        const accessToken = this.configuration.accessToken;
        if (accessToken) {
            return typeof accessToken === 'function' ? accessToken : () => __awaiter(this, void 0, void 0, function* () { return accessToken; });
        }
        return undefined;
    }
    get headers() {
        return this.configuration.headers;
    }
    get credentials() {
        return this.configuration.credentials;
    }
}
function exists(json, key) {
    const value = json[key];
    return value !== null && value !== undefined;
}
function querystring(params, prefix = '') {
    return Object.keys(params)
        .map((key) => {
        const fullKey = prefix + (prefix.length ? `[${key}]` : key);
        const value = params[key];
        if (value instanceof Array) {
            const multiValue = value.map(singleValue => encodeURIComponent(String(singleValue)))
                .join(`&${encodeURIComponent(fullKey)}=`);
            return `${encodeURIComponent(fullKey)}=${multiValue}`;
        }
        if (value instanceof Date) {
            return `${encodeURIComponent(fullKey)}=${encodeURIComponent(value.toISOString())}`;
        }
        if (value instanceof Object) {
            return querystring(value, fullKey);
        }
        return `${encodeURIComponent(fullKey)}=${encodeURIComponent(String(value))}`;
    })
        .filter(part => part.length > 0)
        .join('&');
}
function mapValues(data, fn) {
    return Object.keys(data).reduce((acc, key) => (Object.assign(Object.assign({}, acc), { [key]: fn(data[key]) })), {});
}
function runtime_canConsumeForm(consumes) {
    for (const consume of consumes) {
        if ('multipart/form-data' === consume.contentType) {
            return true;
        }
    }
    return false;
}
class JSONApiResponse {
    constructor(raw, transformer = (jsonValue) => jsonValue) {
        this.raw = raw;
        this.transformer = transformer;
    }
    value() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.transformer(yield this.raw.json());
        });
    }
}
class VoidApiResponse {
    constructor(raw) {
        this.raw = raw;
    }
    value() {
        return __awaiter(this, void 0, void 0, function* () {
            return undefined;
        });
    }
}
class BlobApiResponse {
    constructor(raw) {
        this.raw = raw;
    }
    value() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.raw.blob();
        });
    }
    ;
}
class TextApiResponse {
    constructor(raw) {
        this.raw = raw;
    }
    value() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.raw.text();
        });
    }
    ;
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/AuthLink.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function AuthLinkFromJSON(json) {
    return AuthLinkFromJSONTyped(json, false);
}
function AuthLinkFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'link': json['link'],
        'qrcode': json['qrcode'],
    };
}
function AuthLinkToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'link': value.link,
        'qrcode': value.qrcode,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/CacheCompression.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var CacheCompression;
(function (CacheCompression) {
    CacheCompression["Gzip"] = "gzip";
})(CacheCompression || (CacheCompression = {}));
function CacheCompressionFromJSON(json) {
    return CacheCompressionFromJSONTyped(json, false);
}
function CacheCompressionFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function CacheCompressionToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/CacheIsLiveResponseDto.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function CacheIsLiveResponseDtoFromJSON(json) {
    return CacheIsLiveResponseDtoFromJSONTyped(json, false);
}
function CacheIsLiveResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'status': json['status'],
    };
}
function CacheIsLiveResponseDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'status': value.status,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/CacheUrlRequestDto.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function CacheUrlRequestDtoFromJSON(json) {
    return CacheUrlRequestDtoFromJSONTyped(json, false);
}
function CacheUrlRequestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'url': json['url'],
        'ttl': !exists(json, 'ttl') ? undefined : json['ttl'],
        'compression': !exists(json, 'compression') ? undefined : CacheCompressionFromJSON(json['compression']),
    };
}
function CacheUrlRequestDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'url': value.url,
        'ttl': value.ttl,
        'compression': CacheCompressionToJSON(value.compression),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/FetchJsonOptions.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function FetchJsonOptionsFromJSON(json) {
    return FetchJsonOptionsFromJSONTyped(json, false);
}
function FetchJsonOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'url': json['url'],
        'headers': !exists(json, 'headers') ? undefined : json['headers'],
        'method': json['method'],
        'body': !exists(json, 'body') ? undefined : json['body'],
    };
}
function FetchJsonOptionsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'url': value.url,
        'headers': value.headers,
        'method': value.method,
        'body': value.body,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/KeyboardOpenDto.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function KeyboardOpenDtoFromJSON(json) {
    return KeyboardOpenDtoFromJSONTyped(json, false);
}
function KeyboardOpenDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'position': !exists(json, 'position') ? undefined : json['position'],
    };
}
function KeyboardOpenDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'position': value.position,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/LocalbaseFindOneOptions.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function LocalbaseFindOneOptionsFromJSON(json) {
    return LocalbaseFindOneOptionsFromJSONTyped(json, false);
}
function LocalbaseFindOneOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'query': json['query'],
    };
}
function LocalbaseFindOneOptionsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'query': value.query,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/LocalbaseFindOptions.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function LocalbaseFindOptionsFromJSON(json) {
    return LocalbaseFindOptionsFromJSONTyped(json, false);
}
function LocalbaseFindOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'query': json['query'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
        'skip': !exists(json, 'skip') ? undefined : json['skip'],
        'sort': !exists(json, 'sort') ? undefined : json['sort'],
    };
}
function LocalbaseFindOptionsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'query': value.query,
        'limit': value.limit,
        'skip': value.skip,
        'sort': value.sort,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/LocalbaseUpdateOptions.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function LocalbaseUpdateOptionsFromJSON(json) {
    return LocalbaseUpdateOptionsFromJSONTyped(json, false);
}
function LocalbaseUpdateOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'query': json['query'],
        'update': !exists(json, 'update') ? undefined : json['update'],
    };
}
function LocalbaseUpdateOptionsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'query': value.query,
        'update': value.update,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/PaymentTerminalCommandDto.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function PaymentTerminalCommandDtoFromJSON(json) {
    return PaymentTerminalCommandDtoFromJSONTyped(json, false);
}
function PaymentTerminalCommandDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'paymentTerminal': json['paymentTerminal'],
        'test': !exists(json, 'test') ? undefined : json['test'],
        'data': json['data'],
    };
}
function PaymentTerminalCommandDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'paymentTerminal': value.paymentTerminal,
        'test': value.test,
        'data': value.data,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/PaymentTerminalCorrectionDto.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function PaymentTerminalCorrectionDtoFromJSON(json) {
    return PaymentTerminalCorrectionDtoFromJSONTyped(json, false);
}
function PaymentTerminalCorrectionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'paymentTerminal': json['paymentTerminal'],
        'test': !exists(json, 'test') ? undefined : json['test'],
        'amount': json['amount'],
        'invoice': !exists(json, 'invoice') ? undefined : json['invoice'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'method': !exists(json, 'method') ? undefined : json['method'],
        'originalApproval': !exists(json, 'originalApproval') ? undefined : json['originalApproval'],
        'transaction': !exists(json, 'transaction') ? undefined : PaymentTerminalTransactionResponseFromJSON(json['transaction']),
    };
}
function PaymentTerminalCorrectionDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'paymentTerminal': value.paymentTerminal,
        'test': value.test,
        'amount': value.amount,
        'invoice': value.invoice,
        'type': value.type,
        'method': value.method,
        'originalApproval': value.originalApproval,
        'transaction': PaymentTerminalTransactionResponseToJSON(value.transaction),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/PaymentTerminalDto.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function PaymentTerminalDtoFromJSON(json) {
    return PaymentTerminalDtoFromJSONTyped(json, false);
}
function PaymentTerminalDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'paymentTerminal': json['paymentTerminal'],
        'test': !exists(json, 'test') ? undefined : json['test'],
    };
}
function PaymentTerminalDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'paymentTerminal': value.paymentTerminal,
        'test': value.test,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/PaymentTerminalPurchaseDto.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function PaymentTerminalPurchaseDtoFromJSON(json) {
    return PaymentTerminalPurchaseDtoFromJSONTyped(json, false);
}
function PaymentTerminalPurchaseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'paymentTerminal': json['paymentTerminal'],
        'test': !exists(json, 'test') ? undefined : json['test'],
        'amount': json['amount'],
        'invoice': !exists(json, 'invoice') ? undefined : json['invoice'],
    };
}
function PaymentTerminalPurchaseDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'paymentTerminal': value.paymentTerminal,
        'test': value.test,
        'amount': value.amount,
        'invoice': value.invoice,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/PaymentTerminalRefundDto.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function PaymentTerminalRefundDtoFromJSON(json) {
    return PaymentTerminalRefundDtoFromJSONTyped(json, false);
}
function PaymentTerminalRefundDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'paymentTerminal': json['paymentTerminal'],
        'test': !exists(json, 'test') ? undefined : json['test'],
        'amount': json['amount'],
        'invoice': !exists(json, 'invoice') ? undefined : json['invoice'],
        'method': json['method'],
        'transaction': !exists(json, 'transaction') ? undefined : PaymentTerminalTransactionResponseFromJSON(json['transaction']),
    };
}
function PaymentTerminalRefundDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'paymentTerminal': value.paymentTerminal,
        'test': value.test,
        'amount': value.amount,
        'invoice': value.invoice,
        'method': value.method,
        'transaction': PaymentTerminalTransactionResponseToJSON(value.transaction),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/PaymentTerminalStatus.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var PaymentTerminalStatus;
(function (PaymentTerminalStatus) {
    PaymentTerminalStatus["Approved"] = "approved";
    PaymentTerminalStatus["Success"] = "success";
    PaymentTerminalStatus["Declined"] = "declined";
    PaymentTerminalStatus["NotCompleted"] = "not_completed";
    PaymentTerminalStatus["Unknown"] = "unknown";
    PaymentTerminalStatus["Initialized"] = "initialized";
    PaymentTerminalStatus["Busy"] = "busy";
    PaymentTerminalStatus["Timeout"] = "timeout";
    PaymentTerminalStatus["UserCanceled"] = "user_canceled";
    PaymentTerminalStatus["SystemCanceled"] = "system_canceled";
})(PaymentTerminalStatus || (PaymentTerminalStatus = {}));
function PaymentTerminalStatusFromJSON(json) {
    return PaymentTerminalStatusFromJSONTyped(json, false);
}
function PaymentTerminalStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function PaymentTerminalStatusToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/PaymentTerminalTransactionResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function PaymentTerminalTransactionResponseFromJSON(json) {
    return PaymentTerminalTransactionResponseFromJSONTyped(json, false);
}
function PaymentTerminalTransactionResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': PaymentTerminalTransactionTypeFromJSON(json['type']),
        'status': PaymentTerminalStatusFromJSON(json['status']),
        'customerReceipt': json['customerReceipt'],
        'merchantReceipt': json['merchantReceipt'],
        'data': json['data'],
        'approval': json['approval'],
        'amount': json['amount'],
        'tip': json['tip'],
        'card': json['card'],
        'invoice': json['invoice'],
    };
}
function PaymentTerminalTransactionResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': PaymentTerminalTransactionTypeToJSON(value.type),
        'status': PaymentTerminalStatusToJSON(value.status),
        'customerReceipt': value.customerReceipt,
        'merchantReceipt': value.merchantReceipt,
        'data': value.data,
        'approval': value.approval,
        'amount': value.amount,
        'tip': value.tip,
        'card': value.card,
        'invoice': value.invoice,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/PaymentTerminalTransactionType.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var PaymentTerminalTransactionType;
(function (PaymentTerminalTransactionType) {
    PaymentTerminalTransactionType["Purchase"] = "purchase";
    PaymentTerminalTransactionType["Command"] = "command";
    PaymentTerminalTransactionType["System"] = "system";
    PaymentTerminalTransactionType["Receipt"] = "receipt";
})(PaymentTerminalTransactionType || (PaymentTerminalTransactionType = {}));
function PaymentTerminalTransactionTypeFromJSON(json) {
    return PaymentTerminalTransactionTypeFromJSONTyped(json, false);
}
function PaymentTerminalTransactionTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function PaymentTerminalTransactionTypeToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/PlatformDisplay.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function PlatformDisplayFromJSON(json) {
    return PlatformDisplayFromJSONTyped(json, false);
}
function PlatformDisplayFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'accelerometerSupport': json['accelerometerSupport'],
        'bounds': RectangleFromJSON(json['bounds']),
        'colorDepth': json['colorDepth'],
        'colorSpace': json['colorSpace'],
        'depthPerComponent': json['depthPerComponent'],
        'displayFrequency': json['displayFrequency'],
        'id': json['id'],
        'internal': json['internal'],
        'monochrome': json['monochrome'],
        'rotation': json['rotation'],
        'scaleFactor': json['scaleFactor'],
        'size': SizeFromJSON(json['size']),
        'touchSupport': json['touchSupport'],
        'workArea': RectangleFromJSON(json['workArea']),
        'workAreaSize': SizeFromJSON(json['workAreaSize']),
    };
}
function PlatformDisplayToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'accelerometerSupport': value.accelerometerSupport,
        'bounds': RectangleToJSON(value.bounds),
        'colorDepth': value.colorDepth,
        'colorSpace': value.colorSpace,
        'depthPerComponent': value.depthPerComponent,
        'displayFrequency': value.displayFrequency,
        'id': value.id,
        'internal': value.internal,
        'monochrome': value.monochrome,
        'rotation': value.rotation,
        'scaleFactor': value.scaleFactor,
        'size': SizeToJSON(value.size),
        'touchSupport': value.touchSupport,
        'workArea': RectangleToJSON(value.workArea),
        'workAreaSize': SizeToJSON(value.workAreaSize),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/PlatformNetworkInterface.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function PlatformNetworkInterfaceFromJSON(json) {
    return PlatformNetworkInterfaceFromJSONTyped(json, false);
}
function PlatformNetworkInterfaceFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'address': json['address'],
        'cidr': json['cidr'],
        'family': json['family'],
        'internal': json['internal'],
        'mac': json['mac'],
        'name': json['name'],
        'netmask': json['netmask'],
        'scopeid': json['scopeid'],
    };
}
function PlatformNetworkInterfaceToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'address': value.address,
        'cidr': value.cidr,
        'family': value.family,
        'internal': value.internal,
        'mac': value.mac,
        'name': value.name,
        'netmask': value.netmask,
        'scopeid': value.scopeid,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/PlatformOSInfo.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function PlatformOSInfoFromJSON(json) {
    return PlatformOSInfoFromJSONTyped(json, false);
}
function PlatformOSInfoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'freemem': json['freemem'],
        'homedir': json['homedir'],
        'hostname': json['hostname'],
        'networkInterfaces': (json['networkInterfaces'].map(PlatformNetworkInterfaceFromJSON)),
        'release': json['release'],
        'totalmem': json['totalmem'],
        'uptime': json['uptime'],
        'userInfo': json['userInfo'],
        'version': json['version'],
    };
}
function PlatformOSInfoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'freemem': value.freemem,
        'homedir': value.homedir,
        'hostname': value.hostname,
        'networkInterfaces': (value.networkInterfaces.map(PlatformNetworkInterfaceToJSON)),
        'release': value.release,
        'totalmem': value.totalmem,
        'uptime': value.uptime,
        'userInfo': value.userInfo,
        'version': value.version,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/PlatformPrinter.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function PlatformPrinterFromJSON(json) {
    return PlatformPrinterFromJSONTyped(json, false);
}
function PlatformPrinterFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'description': json['description'],
        'displayName': json['displayName'],
        'isDefault': json['isDefault'],
        'name': json['name'],
        'options': json['options'],
        'status': json['status'],
    };
}
function PlatformPrinterToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'description': value.description,
        'displayName': value.displayName,
        'isDefault': value.isDefault,
        'name': value.name,
        'options': value.options,
        'status': value.status,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/PlatformState.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function PlatformStateFromJSON(json) {
    return PlatformStateFromJSONTyped(json, false);
}
function PlatformStateFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'date': (new Date(json['date'])),
        'devices': json['devices'],
        'displays': (json['displays'].map(PlatformDisplayFromJSON)),
        'nodeVersion': json['nodeVersion'],
        'os': PlatformOSInfoFromJSON(json['os']),
        'platform': json['platform'],
        'primaryDisplay': json['primaryDisplay'],
        'printers': (json['printers'].map(PlatformPrinterFromJSON)),
        'publicIPV4': json['publicIPV4'],
        'publicIPV6': json['publicIPV6'],
        'speedTest': !exists(json, 'speedTest') ? undefined : json['speedTest'],
        'version': json['version'],
    };
}
function PlatformStateToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'date': (value.date.toISOString()),
        'devices': value.devices,
        'displays': (value.displays.map(PlatformDisplayToJSON)),
        'nodeVersion': value.nodeVersion,
        'os': PlatformOSInfoToJSON(value.os),
        'platform': value.platform,
        'primaryDisplay': value.primaryDisplay,
        'printers': (value.printers.map(PlatformPrinterToJSON)),
        'publicIPV4': value.publicIPV4,
        'publicIPV6': value.publicIPV6,
        'speedTest': value.speedTest,
        'version': value.version,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/PlayerProfileSetDto.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function PlayerProfileSetDtoFromJSON(json) {
    return PlayerProfileSetDtoFromJSONTyped(json, false);
}
function PlayerProfileSetDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'connectionRequired': !exists(json, 'connectionRequired') ? undefined : json['connectionRequired'],
        'height': !exists(json, 'height') ? undefined : json['height'],
        'password': json['password'],
        'secure': !exists(json, 'secure') ? undefined : json['secure'],
        'url': json['url'],
        'username': json['username'],
        'width': !exists(json, 'width') ? undefined : json['width'],
        'x': !exists(json, 'x') ? undefined : json['x'],
        'y': !exists(json, 'y') ? undefined : json['y'],
    };
}
function PlayerProfileSetDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'connectionRequired': value.connectionRequired,
        'height': value.height,
        'password': value.password,
        'secure': value.secure,
        'url': value.url,
        'username': value.username,
        'width': value.width,
        'x': value.x,
        'y': value.y,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/PreviewConfigDto.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function PreviewConfigDtoFromJSON(json) {
    return PreviewConfigDtoFromJSONTyped(json, false);
}
function PreviewConfigDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'url': json['url'],
        'width': json['width'],
        'height': json['height'],
        'display': !exists(json, 'display') ? undefined : json['display'],
        'username': json['username'],
        'password': json['password'],
    };
}
function PreviewConfigDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'url': value.url,
        'width': value.width,
        'height': value.height,
        'display': value.display,
        'username': value.username,
        'password': value.password,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/PrintHtmlDto.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


function PrintHtmlDtoFromJSON(json) {
    return PrintHtmlDtoFromJSONTyped(json, false);
}
function PrintHtmlDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'options': !exists(json, 'options') ? undefined : PrintOptionsFromJSON(json['options']),
        'printerName': json['printerName'],
        'html': json['html'],
    };
}
function PrintHtmlDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'options': PrintOptionsToJSON(value.options),
        'printerName': value.printerName,
        'html': value.html,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/PrintOptions.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function PrintOptionsFromJSON(json) {
    return PrintOptionsFromJSONTyped(json, false);
}
function PrintOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'copies': !exists(json, 'copies') ? undefined : json['copies'],
        'pageRanges': !exists(json, 'pageRanges') ? undefined : json['pageRanges'],
        'pageSize': !exists(json, 'pageSize') ? undefined : json['pageSize'],
        'scaleFactor': !exists(json, 'scaleFactor') ? undefined : json['scaleFactor'],
        'silent': !exists(json, 'silent') ? undefined : json['silent'],
    };
}
function PrintOptionsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'copies': value.copies,
        'pageRanges': value.pageRanges,
        'pageSize': value.pageSize,
        'scaleFactor': value.scaleFactor,
        'silent': value.silent,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/PrinterResponse.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

function PrinterResponseFromJSON(json) {
    return PrinterResponseFromJSONTyped(json, false);
}
function PrinterResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'status': PrinterStatusFromJSON(json['status']),
    };
}
function PrinterResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'status': PrinterStatusToJSON(value.status),
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/PrinterStatus.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var PrinterStatus;
(function (PrinterStatus) {
    PrinterStatus["Success"] = "success";
    PrinterStatus["Error"] = "error";
})(PrinterStatus || (PrinterStatus = {}));
function PrinterStatusFromJSON(json) {
    return PrinterStatusFromJSONTyped(json, false);
}
function PrinterStatusFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function PrinterStatusToJSON(value) {
    return value;
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/Rectangle.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function RectangleFromJSON(json) {
    return RectangleFromJSONTyped(json, false);
}
function RectangleFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'height': json['height'],
        'width': json['width'],
        'x': json['x'],
        'y': json['y'],
    };
}
function RectangleToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'height': value.height,
        'width': value.width,
        'x': value.x,
        'y': value.y,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/ShopifyApiRequest.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function ShopifyApiRequestFromJSON(json) {
    return ShopifyApiRequestFromJSONTyped(json, false);
}
function ShopifyApiRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'apiKey': json['apiKey'],
        'password': json['password'],
        'shopName': json['shopName'],
        'request': json['request'],
    };
}
function ShopifyApiRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'apiKey': value.apiKey,
        'password': value.password,
        'shopName': value.shopName,
        'request': value.request,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/Size.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function SizeFromJSON(json) {
    return SizeFromJSONTyped(json, false);
}
function SizeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'height': json['height'],
        'width': json['width'],
    };
}
function SizeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'height': value.height,
        'width': value.width,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/ValidateEmailOptions.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
function ValidateEmailOptionsFromJSON(json) {
    return ValidateEmailOptionsFromJSONTyped(json, false);
}
function ValidateEmailOptionsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'email': json['email'],
    };
}
function ValidateEmailOptionsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'email': value.email,
    };
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/models/index.ts
/* tslint:disable */
/* eslint-disable */

































;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/apis/DefaultApi.ts
/* tslint:disable */
/* eslint-disable */
/**
 * Eflyn E Suite Platform API
 * Platform API for Eflyn Kiosks
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 *
 */
class DefaultApi extends BaseAPI {
    /**
     */
    adminControllerCloseRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/admin/close`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    adminControllerClose(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.adminControllerCloseRaw(initOverrides);
        });
    }
    /**
     */
    adminControllerOpenRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/admin/open`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    adminControllerOpen(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.adminControllerOpenRaw(initOverrides);
        });
    }
    /**
     */
    appControllerGeneralStatsRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    appControllerGeneralStats(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.appControllerGeneralStatsRaw(initOverrides);
        });
    }
    /**
     */
    cacheControllerInvalidateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.key === null || requestParameters.key === undefined) {
                throw new RequiredError('key', 'Required parameter requestParameters.key was null or undefined when calling cacheControllerInvalidate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/cache/invalidate/{key}`.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters.key))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => CacheIsLiveResponseDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    cacheControllerInvalidate(key, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.cacheControllerInvalidateRaw({ key: key }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    cacheControllerIsLiveRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.key === null || requestParameters.key === undefined) {
                throw new RequiredError('key', 'Required parameter requestParameters.key was null or undefined when calling cacheControllerIsLive.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/cache/is_live/{key}`.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters.key))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => CacheIsLiveResponseDtoFromJSON(jsonValue));
        });
    }
    /**
     */
    cacheControllerIsLive(key, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.cacheControllerIsLiveRaw({ key: key }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    cacheControllerUrlRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.cacheUrlRequestDto === null || requestParameters.cacheUrlRequestDto === undefined) {
                throw new RequiredError('cacheUrlRequestDto', 'Required parameter requestParameters.cacheUrlRequestDto was null or undefined when calling cacheControllerUrl.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/cache/url`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CacheUrlRequestDtoToJSON(requestParameters.cacheUrlRequestDto),
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    cacheControllerUrl(cacheUrlRequestDto, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.cacheControllerUrlRaw({ cacheUrlRequestDto: cacheUrlRequestDto }, initOverrides);
        });
    }
    /**
     */
    fetchControllerJsonRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.fetchJsonOptions === null || requestParameters.fetchJsonOptions === undefined) {
                throw new RequiredError('fetchJsonOptions', 'Required parameter requestParameters.fetchJsonOptions was null or undefined when calling fetchControllerJson.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/fetch`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: FetchJsonOptionsToJSON(requestParameters.fetchJsonOptions),
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    fetchControllerJson(fetchJsonOptions, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.fetchControllerJsonRaw({ fetchJsonOptions: fetchJsonOptions }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    helpersControllerCheckEmailRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.validateEmailOptions === null || requestParameters.validateEmailOptions === undefined) {
                throw new RequiredError('validateEmailOptions', 'Required parameter requestParameters.validateEmailOptions was null or undefined when calling helpersControllerCheckEmail.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/helpers/check_email`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ValidateEmailOptionsToJSON(requestParameters.validateEmailOptions),
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    helpersControllerCheckEmail(validateEmailOptions, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.helpersControllerCheckEmailRaw({ validateEmailOptions: validateEmailOptions }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    keyboardControllerCloseRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/keyboard/close`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    keyboardControllerClose(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.keyboardControllerCloseRaw(initOverrides);
        });
    }
    /**
     */
    keyboardControllerOpenRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.keyboardOpenDto === null || requestParameters.keyboardOpenDto === undefined) {
                throw new RequiredError('keyboardOpenDto', 'Required parameter requestParameters.keyboardOpenDto was null or undefined when calling keyboardControllerOpen.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/keyboard/open`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: KeyboardOpenDtoToJSON(requestParameters.keyboardOpenDto),
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    keyboardControllerOpen(keyboardOpenDto, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.keyboardControllerOpenRaw({ keyboardOpenDto: keyboardOpenDto }, initOverrides);
        });
    }
    /**
     */
    localbaseControllerFindRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.cacheKey === null || requestParameters.cacheKey === undefined) {
                throw new RequiredError('cacheKey', 'Required parameter requestParameters.cacheKey was null or undefined when calling localbaseControllerFind.');
            }
            if (requestParameters.collection === null || requestParameters.collection === undefined) {
                throw new RequiredError('collection', 'Required parameter requestParameters.collection was null or undefined when calling localbaseControllerFind.');
            }
            if (requestParameters.localbaseFindOptions === null || requestParameters.localbaseFindOptions === undefined) {
                throw new RequiredError('localbaseFindOptions', 'Required parameter requestParameters.localbaseFindOptions was null or undefined when calling localbaseControllerFind.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/localbase/{cacheKey}/{collection}/find`.replace(`{${"cacheKey"}}`, encodeURIComponent(String(requestParameters.cacheKey))).replace(`{${"collection"}}`, encodeURIComponent(String(requestParameters.collection))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: LocalbaseFindOptionsToJSON(requestParameters.localbaseFindOptions),
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    localbaseControllerFind(cacheKey, collection, localbaseFindOptions, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.localbaseControllerFindRaw({ cacheKey: cacheKey, collection: collection, localbaseFindOptions: localbaseFindOptions }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    localbaseControllerFindOneRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.cacheKey === null || requestParameters.cacheKey === undefined) {
                throw new RequiredError('cacheKey', 'Required parameter requestParameters.cacheKey was null or undefined when calling localbaseControllerFindOne.');
            }
            if (requestParameters.collection === null || requestParameters.collection === undefined) {
                throw new RequiredError('collection', 'Required parameter requestParameters.collection was null or undefined when calling localbaseControllerFindOne.');
            }
            if (requestParameters.localbaseFindOneOptions === null || requestParameters.localbaseFindOneOptions === undefined) {
                throw new RequiredError('localbaseFindOneOptions', 'Required parameter requestParameters.localbaseFindOneOptions was null or undefined when calling localbaseControllerFindOne.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/localbase/{cacheKey}/{collection}/find_one`.replace(`{${"cacheKey"}}`, encodeURIComponent(String(requestParameters.cacheKey))).replace(`{${"collection"}}`, encodeURIComponent(String(requestParameters.collection))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: LocalbaseFindOneOptionsToJSON(requestParameters.localbaseFindOneOptions),
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    localbaseControllerFindOne(cacheKey, collection, localbaseFindOneOptions, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.localbaseControllerFindOneRaw({ cacheKey: cacheKey, collection: collection, localbaseFindOneOptions: localbaseFindOneOptions }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    localbaseControllerUpdateRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.cacheKey === null || requestParameters.cacheKey === undefined) {
                throw new RequiredError('cacheKey', 'Required parameter requestParameters.cacheKey was null or undefined when calling localbaseControllerUpdate.');
            }
            if (requestParameters.collection === null || requestParameters.collection === undefined) {
                throw new RequiredError('collection', 'Required parameter requestParameters.collection was null or undefined when calling localbaseControllerUpdate.');
            }
            if (requestParameters.localbaseUpdateOptions === null || requestParameters.localbaseUpdateOptions === undefined) {
                throw new RequiredError('localbaseUpdateOptions', 'Required parameter requestParameters.localbaseUpdateOptions was null or undefined when calling localbaseControllerUpdate.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/localbase/{cacheKey}/{collection}/update`.replace(`{${"cacheKey"}}`, encodeURIComponent(String(requestParameters.cacheKey))).replace(`{${"collection"}}`, encodeURIComponent(String(requestParameters.collection))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: LocalbaseUpdateOptionsToJSON(requestParameters.localbaseUpdateOptions),
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    localbaseControllerUpdate(cacheKey, collection, localbaseUpdateOptions, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.localbaseControllerUpdateRaw({ cacheKey: cacheKey, collection: collection, localbaseUpdateOptions: localbaseUpdateOptions }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    paymentTerminalControllerCancelRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.paymentTerminalDto === null || requestParameters.paymentTerminalDto === undefined) {
                throw new RequiredError('paymentTerminalDto', 'Required parameter requestParameters.paymentTerminalDto was null or undefined when calling paymentTerminalControllerCancel.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/hardware/payment_terminal/cancel`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: PaymentTerminalDtoToJSON(requestParameters.paymentTerminalDto),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => PaymentTerminalTransactionResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    paymentTerminalControllerCancel(paymentTerminalDto, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.paymentTerminalControllerCancelRaw({ paymentTerminalDto: paymentTerminalDto }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    paymentTerminalControllerCommandRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.paymentTerminalCommandDto === null || requestParameters.paymentTerminalCommandDto === undefined) {
                throw new RequiredError('paymentTerminalCommandDto', 'Required parameter requestParameters.paymentTerminalCommandDto was null or undefined when calling paymentTerminalControllerCommand.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/hardware/payment_terminal/command`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: PaymentTerminalCommandDtoToJSON(requestParameters.paymentTerminalCommandDto),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => PaymentTerminalTransactionResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    paymentTerminalControllerCommand(paymentTerminalCommandDto, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.paymentTerminalControllerCommandRaw({ paymentTerminalCommandDto: paymentTerminalCommandDto }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    paymentTerminalControllerCorrectionRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.paymentTerminalCorrectionDto === null || requestParameters.paymentTerminalCorrectionDto === undefined) {
                throw new RequiredError('paymentTerminalCorrectionDto', 'Required parameter requestParameters.paymentTerminalCorrectionDto was null or undefined when calling paymentTerminalControllerCorrection.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/hardware/payment_terminal/correction`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: PaymentTerminalCorrectionDtoToJSON(requestParameters.paymentTerminalCorrectionDto),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => PaymentTerminalTransactionResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    paymentTerminalControllerCorrection(paymentTerminalCorrectionDto, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.paymentTerminalControllerCorrectionRaw({ paymentTerminalCorrectionDto: paymentTerminalCorrectionDto }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    paymentTerminalControllerPurchaseRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.paymentTerminalPurchaseDto === null || requestParameters.paymentTerminalPurchaseDto === undefined) {
                throw new RequiredError('paymentTerminalPurchaseDto', 'Required parameter requestParameters.paymentTerminalPurchaseDto was null or undefined when calling paymentTerminalControllerPurchase.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/hardware/payment_terminal/purchase`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: PaymentTerminalPurchaseDtoToJSON(requestParameters.paymentTerminalPurchaseDto),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => PaymentTerminalTransactionResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    paymentTerminalControllerPurchase(paymentTerminalPurchaseDto, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.paymentTerminalControllerPurchaseRaw({ paymentTerminalPurchaseDto: paymentTerminalPurchaseDto }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    paymentTerminalControllerRefundRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.paymentTerminalRefundDto === null || requestParameters.paymentTerminalRefundDto === undefined) {
                throw new RequiredError('paymentTerminalRefundDto', 'Required parameter requestParameters.paymentTerminalRefundDto was null or undefined when calling paymentTerminalControllerRefund.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/hardware/payment_terminal/refund`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: PaymentTerminalRefundDtoToJSON(requestParameters.paymentTerminalRefundDto),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => PaymentTerminalTransactionResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    paymentTerminalControllerRefund(paymentTerminalRefundDto, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.paymentTerminalControllerRefundRaw({ paymentTerminalRefundDto: paymentTerminalRefundDto }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    platformControllerCheckForUpdateRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/platform/updates/check`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    platformControllerCheckForUpdate(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.platformControllerCheckForUpdateRaw(initOverrides);
        });
    }
    /**
     */
    platformControllerDownloadAndInstallRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/platform/updates/download_and_install`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    platformControllerDownloadAndInstall(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.platformControllerDownloadAndInstallRaw(initOverrides);
        });
    }
    /**
     */
    platformControllerGetAuthLinkRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/platform/auth_link`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => AuthLinkFromJSON(jsonValue));
        });
    }
    /**
     */
    platformControllerGetAuthLink(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.platformControllerGetAuthLinkRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    platformControllerGetStatusRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/platform/status`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => PlatformStateFromJSON(jsonValue));
        });
    }
    /**
     */
    platformControllerGetStatus(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.platformControllerGetStatusRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    platformControllerInstallUpdateRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/platform/updates/install`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    platformControllerInstallUpdate(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.platformControllerInstallUpdateRaw(initOverrides);
        });
    }
    /**
     */
    playerControllerCloseRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.username === null || requestParameters.username === undefined) {
                throw new RequiredError('username', 'Required parameter requestParameters.username was null or undefined when calling playerControllerClose.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/profiles/{username}/actions/close`.replace(`{${"username"}}`, encodeURIComponent(String(requestParameters.username))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    playerControllerClose(username, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.playerControllerCloseRaw({ username: username }, initOverrides);
        });
    }
    /**
     */
    playerControllerOpenDevToolsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.username === null || requestParameters.username === undefined) {
                throw new RequiredError('username', 'Required parameter requestParameters.username was null or undefined when calling playerControllerOpenDevTools.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/profiles/{username}/actions/open_dev_tools`.replace(`{${"username"}}`, encodeURIComponent(String(requestParameters.username))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    playerControllerOpenDevTools(username, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.playerControllerOpenDevToolsRaw({ username: username }, initOverrides);
        });
    }
    /**
     */
    playerControllerRemoveProfileRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.username === null || requestParameters.username === undefined) {
                throw new RequiredError('username', 'Required parameter requestParameters.username was null or undefined when calling playerControllerRemoveProfile.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/profiles/{username}`.replace(`{${"username"}}`, encodeURIComponent(String(requestParameters.username))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    playerControllerRemoveProfile(username, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.playerControllerRemoveProfileRaw({ username: username }, initOverrides);
        });
    }
    /**
     */
    playerControllerSetProfileRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.playerProfileSetDto === null || requestParameters.playerProfileSetDto === undefined) {
                throw new RequiredError('playerProfileSetDto', 'Required parameter requestParameters.playerProfileSetDto was null or undefined when calling playerControllerSetProfile.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/profiles`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: PlayerProfileSetDtoToJSON(requestParameters.playerProfileSetDto),
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    playerControllerSetProfile(playerProfileSetDto, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.playerControllerSetProfileRaw({ playerProfileSetDto: playerProfileSetDto }, initOverrides);
        });
    }
    /**
     */
    previewControllerCloseRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/preview`,
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    previewControllerClose(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.previewControllerCloseRaw(initOverrides);
        });
    }
    /**
     */
    previewControllerConfigureRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.previewConfigDto === null || requestParameters.previewConfigDto === undefined) {
                throw new RequiredError('previewConfigDto', 'Required parameter requestParameters.previewConfigDto was null or undefined when calling previewControllerConfigure.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/preview`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: PreviewConfigDtoToJSON(requestParameters.previewConfigDto),
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    previewControllerConfigure(previewConfigDto, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.previewControllerConfigureRaw({ previewConfigDto: previewConfigDto }, initOverrides);
        });
    }
    /**
     */
    printerControllerCashdrawerRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.printHtmlDto === null || requestParameters.printHtmlDto === undefined) {
                throw new RequiredError('printHtmlDto', 'Required parameter requestParameters.printHtmlDto was null or undefined when calling printerControllerCashdrawer.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/hardware/printer/print/cashdrawer`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: PrintHtmlDtoToJSON(requestParameters.printHtmlDto),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => PrinterResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    printerControllerCashdrawer(printHtmlDto, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.printerControllerCashdrawerRaw({ printHtmlDto: printHtmlDto }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    printerControllerPrintHtmlRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.printHtmlDto === null || requestParameters.printHtmlDto === undefined) {
                throw new RequiredError('printHtmlDto', 'Required parameter requestParameters.printHtmlDto was null or undefined when calling printerControllerPrintHtml.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/hardware/printer/print/html`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: PrintHtmlDtoToJSON(requestParameters.printHtmlDto),
            }, initOverrides);
            return new JSONApiResponse(response, (jsonValue) => PrinterResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    printerControllerPrintHtml(printHtmlDto, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.printerControllerPrintHtmlRaw({ printHtmlDto: printHtmlDto }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    printerControllerPrintPDFRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const consumes = [
                { contentType: 'multipart/form-data' },
            ];
            // @ts-ignore: canConsumeForm may be unused
            const canConsumeForm = runtime_canConsumeForm(consumes);
            let formParams;
            let useForm = false;
            // use FormData to transmit files using content-type "multipart/form-data"
            useForm = canConsumeForm;
            if (useForm) {
                formParams = new FormData();
            }
            else {
                formParams = new URLSearchParams();
            }
            if (requestParameters.pdf !== undefined) {
                formParams.append('pdf', requestParameters.pdf);
            }
            const response = yield this.request({
                path: `/hardware/printer/print/pdf`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: formParams,
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    printerControllerPrintPDF(pdf, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.printerControllerPrintPDFRaw({ pdf: pdf }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    shopifyControllerApiRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.shopifyApiRequest === null || requestParameters.shopifyApiRequest === undefined) {
                throw new RequiredError('shopifyApiRequest', 'Required parameter requestParameters.shopifyApiRequest was null or undefined when calling shopifyControllerApi.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/shopify/api`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ShopifyApiRequestToJSON(requestParameters.shopifyApiRequest),
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    shopifyControllerApi(shopifyApiRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.shopifyControllerApiRaw({ shopifyApiRequest: shopifyApiRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    shopifyControllerGraphqlRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.shopifyApiRequest === null || requestParameters.shopifyApiRequest === undefined) {
                throw new RequiredError('shopifyApiRequest', 'Required parameter requestParameters.shopifyApiRequest was null or undefined when calling shopifyControllerGraphql.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/shopify/graphql`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ShopifyApiRequestToJSON(requestParameters.shopifyApiRequest),
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    shopifyControllerGraphql(shopifyApiRequest, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.shopifyControllerGraphqlRaw({ shopifyApiRequest: shopifyApiRequest }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    storageControllerGetJsonRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.key === null || requestParameters.key === undefined) {
                throw new RequiredError('key', 'Required parameter requestParameters.key was null or undefined when calling storageControllerGetJson.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/storage/storage/{key}`.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters.key))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new JSONApiResponse(response);
        });
    }
    /**
     */
    storageControllerGetJson(key, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.storageControllerGetJsonRaw({ key: key }, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    storageControllerSetJsonRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.key === null || requestParameters.key === undefined) {
                throw new RequiredError('key', 'Required parameter requestParameters.key was null or undefined when calling storageControllerSetJson.');
            }
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling storageControllerSetJson.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/storage/storage/{key}`.replace(`{${"key"}}`, encodeURIComponent(String(requestParameters.key))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: requestParameters.body,
            }, initOverrides);
            return new VoidApiResponse(response);
        });
    }
    /**
     */
    storageControllerSetJson(key, body, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.storageControllerSetJsonRaw({ key: key, body: body }, initOverrides);
        });
    }
}

;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/apis/index.ts
/* tslint:disable */
/* eslint-disable */


;// CONCATENATED MODULE: ./client/lib/esuite-platform-api/index.ts
/* tslint:disable */
/* eslint-disable */




;// CONCATENATED MODULE: ./client/lib/extras/public_api.ts
const testExtra = () => {
};

;// CONCATENATED MODULE: ./client/lib/extras/index.ts
/* Exports all additional functionality that is to be implemented in
EsuitePlatformClient
 */


;// CONCATENATED MODULE: ./client/lib/controller-remap.ts
/*
Remap Controller Names
 */
const controllerRemap = {
    images: 'imageUpload',
};
const getRemap = (resource) => {
    for (const key of Object.keys(controllerRemap)) {
        if (controllerRemap[key] === resource) {
            return key;
        }
    }
};

;// CONCATENATED MODULE: ./client/lib/esuite-client.ts



/*
Constants
 */
const TOKEN_KEY = '__ESUITE_PLATFORM_CLIENT_ACCESS_TOKEN';
/*
Additional Hooks to extend base API functionality
 */
const beforeHooks = {};
const afterHooks = {
// auth: {
//   // Automatically assign key to memory so we can retrieve and refresh.
//   refreshToken: (resp) => {
//     (kioskWindow as any)[TOKEN_KEY] = resp.token;
//     // Todo: add logic here to auto refresh the token.
//   },
//   authenticate: (resp) => {
//     (kioskWindow as any)[TOKEN_KEY] = resp.token;
//   }
// }
};
var ApiVersion;
(function (ApiVersion) {
    ApiVersion["V1"] = "v1";
})(ApiVersion || (ApiVersion = {}));
/*
Given an API configuration object this function will create and return an instance
of EsuitePlatformClient. Internally reformats a standard Swagger API with additional configurations and
more hierarchical structure.
 */
const createEsuitePlatformClient = (config = {}, version = ApiVersion.V1) => {
    const basePath = config.domain || (window.location.protocol + '//' + window.location.host);
    // let basePath = config.domain || BASE_PATH.replace('localhost:3000', kioskWindow.location.pedAddress);
    // if (!config.domain) {
    //   if (config.organizationName) {
    //     basePath = basePath.replace('my-organization', config.organizationName);
    //   } else {
    //     const domains = kioskWindow.location.hostname.split('.');
    //     basePath = basePath.replace('my-organization.', domains.length > 1 ? domains[0] + '.' : '');
    //   }
    // }
    // let { accessToken } = config;
    // if (!accessToken) {
    const accessToken = () => window[TOKEN_KEY];
    // }
    const apiConfig = new Configuration({ basePath: (config === null || config === void 0 ? void 0 : config.domain) || 'http://localhost:3100' });
    return buildClient(DefaultApi, apiConfig, version);
};
function buildClient(apiType, apiConfig, apiVersion) {
    const baseApi = new DefaultApi(apiConfig);
    const client = {};
    // Loop through parent object for all API methods.
    for (const resourceMethodKey of Object.getOwnPropertyNames(Object.getPrototypeOf(baseApi))) {
        // Filter only public Controller methods (without Raw suffix)
        if (resourceMethodKey.indexOf('Controller') > -1 && resourceMethodKey.lastIndexOf('Raw') !== (resourceMethodKey.length - 3)) {
            const resource = resourceMethodKey.slice(0, resourceMethodKey.indexOf('Controller'));
            let version = (resourceMethodKey.slice(resourceMethodKey.indexOf('Controller') + 10).match(/V([0-9]*)/) || [''])[0];
            let methodKey = resourceMethodKey.slice(resourceMethodKey.indexOf('Controller') + 10).replace(version, '');
            // Remap resource key if any remaps
            let resourceRemap = getRemap(resource);
            // If the API is versioned make sure to skip it if it does not match the current version
            if (version && version.toLowerCase() !== apiVersion.toLowerCase()) {
                continue;
            }
            // Ensure client object exists
            if (!client[resource]) {
                client[resource] = {};
            }
            // Ensure client object exists
            if (resourceRemap && !client[resourceRemap]) {
                client[resourceRemap] = {};
            }
            // Assign methodKey by extracting method key from full method name.
            methodKey = methodKey.slice(0, 1).toLowerCase() + methodKey.slice(1);
            // Set method key with reference to baseApi method
            client[resource][methodKey] = (...args) => {
                var _a;
                // Run Before Hooks and pass arguments
                if ((_a = beforeHooks[resource]) === null || _a === void 0 ? void 0 : _a[methodKey]) {
                    beforeHooks[resource][methodKey](...args);
                }
                return baseApi[resourceMethodKey].apply(baseApi, args)
                    .then(resp => {
                    var _a;
                    // Run after hooks with results of the API
                    if ((_a = afterHooks[resource]) === null || _a === void 0 ? void 0 : _a[methodKey]) {
                        afterHooks[resource][methodKey](resp);
                    }
                    return resp;
                });
            };
            if (resourceRemap) {
                client[resourceRemap] = client[resource];
            }
        }
    }
    // Load extra methods
    if (extras_namespaceObject) {
        for (const resourceGeneratorKey of Object.keys(extras_namespaceObject)) {
            const extraMethods = extras_namespaceObject[resourceGeneratorKey](client);
            if (extraMethods) {
                for (const methodKey of Object.keys(extraMethods)) {
                    client[resourceGeneratorKey][methodKey] = extraMethods[methodKey];
                }
            }
        }
    }
    return client;
}

;// CONCATENATED MODULE: ./client/lib/public_api.ts
/*
Consumes generated Swagger API and re-exports re-structured and re-typed version.
With additional configuration options including sub-domain setup.
 */


;// CONCATENATED MODULE: ./client/lib/api-structure.ts
class EsuitePlatformClient {
    constructor() {
        this.admin = {};
        this.app = {};
        this.cache = {};
        this.fetch = {};
        this.helpers = {};
        this.keyboard = {};
        this.localbase = {};
        this.paymentTerminal = {};
        this.platform = {};
        this.player = {};
        this.preview = {};
        this.printer = {};
        this.shopify = {};
        this.storage = {};
    }
}
;
/*
type BaseClientRemapper = {
    [K in keyof ControllerRemap]: BaseClient[ControllerRemap[K]];
}

export type EsuitePlatformClient = BaseClient & BaseClientRemapper;
*/

;// CONCATENATED MODULE: ./client/lib/index.ts






/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop)
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	// module exports must be returned from runtime so entry inlining is disabled
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(462);
/******/ })()
;
});